var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnShowpass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 5.97571C14.123 5.92619 14.5564 5.90002 15 5.90002C23.2727 5.90002 28 15 28 15C28 15 27.1007 16.7312 25.4 18.6836M8.1266 8.1394C4.16423 10.8339 2 15 2 15C2 15 6.72727 24.1 15 24.1C17.6654 24.1 19.9626 23.1554 21.8524 21.8749L8.1266 8.1394Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 5.97571C14.123 5.92619 14.5564 5.90002 15 5.90002C23.2727 5.90002 28 15 28 15C28 15 27.1007 16.7312 25.4 18.6836M8.1266 8.1394C4.16423 10.8339 2 15 2 15C2 15 6.72727 24.1 15 24.1C17.6654 24.1 19.9626 23.1554 21.8524 21.8749L8.1266 8.1394Z",
    stroke: "#F68D10",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 17.9071C16.9096 18.5246 15.9985 18.9001 14.9996 18.9001C12.8456 18.9001 11.0996 17.1541 11.0996 15.0001C11.0996 13.9293 11.5311 12.9594 12.2297 12.2546",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 17.9071C16.9096 18.5246 15.9985 18.9001 14.9996 18.9001C12.8456 18.9001 11.0996 17.1541 11.0996 15.0001C11.0996 13.9293 11.5311 12.9594 12.2297 12.2546",
    stroke: "#F68D10",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L28 28",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L28 28",
    stroke: "#F68D10",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnShowpass);
export default __webpack_public_path__ + "static/media/unShowpass.788f379e353ee1da1eae35b5969d55d3.svg";
export { ForwardRef as ReactComponent };